import React from "react";
import "./HeadSpaImg.css";
import headSpaImg from "./../../../../../Images/SpaInnerPage/Head Massage.png";
const HeadSpaImg = () => {
  return (
    <div className="headSpaImgContainer">
      <img src={headSpaImg} alt="headSpaImg" />
    </div>
  );
};

export default HeadSpaImg;
